exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faohraGWtYoA3agb3pV9s {\n    cursor: pointer;\n}\n\n._2cjAiGdXUeASoMYHsBR8eh {\n    width: 200px;\n}\n\n._3G2fjN_5K3Dg_gi7d1-m91 {\n    width: 200px;\n}", ""]);

// exports
exports.locals = {
	"userRow": "faohraGWtYoA3agb3pV9s",
	"remarksEditInput": "_2cjAiGdXUeASoMYHsBR8eh",
	"emailEditInput": "_3G2fjN_5K3Dg_gi7d1-m91"
};